/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Agents_TitleInputs */

const en_wc_why_agents_title = /** @type {(inputs: Wc_Why_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for AI agents`)
};

/**
* | output |
* | --- |
* | "Built for AI agents" |
*
* @param {Wc_Why_Agents_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_agents_title = /** @type {((inputs?: Wc_Why_Agents_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Agents_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_agents_title(inputs)
});
export { wc_why_agents_title as "wc.why.agents.title" }